__turbopack_context__.v({
  "focused": "FormSelector-module-scss-module__-ioQgq__focused",
  "form-selector": "FormSelector-module-scss-module__-ioQgq__form-selector",
  "form-selector-input": "FormSelector-module-scss-module__-ioQgq__form-selector-input",
  "form-selector-label": "FormSelector-module-scss-module__-ioQgq__form-selector-label",
});
